import React, { createContext, useEffect, useState } from "react";
import LoadingOverlay from "../components/LoadingOverlay";
import { decodeJwtPayload } from "./jwtUtils";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);

  const updateUser = (newUser) => {
    setUser(newUser);
  };

  useEffect(() => {
    let token = sessionStorage.getItem("token");
    if (!token) {
      sessionStorage.removeItem("token");
      setUser({});
      setLoading(false);
      return;
    }
    const payload = decodeJwtPayload(token);
    setUser(payload);
    setLoading(false);
  }, []);

  const logout = () => {
    sessionStorage.removeItem("token");
    setUser({});
  };

  return (
    <UserContext.Provider value={{ user, updateUser, logout }}>
      {loading ? <LoadingOverlay /> : children}
    </UserContext.Provider>
  );
};
